(function($) {
$.fn.slider = function(options) {
    var settings = $.extend({

        marginY : 30 ,
        marginX : 30 ,
        setX  : 30,
        setY  : 30,
        direction   : "horizontal"

    } , options);
    
    return this.each(function() {
    // Initialization
    ////////////////////////////////

        var $this = $(this),
                $changeable = $this.find('.changeable'),
                $handle = $this.find('.handle'),
                width  = $this.innerWidth(),
                height = $this.innerHeight(),
                pos_x  = null,
                pos_y  = null,
                startX = null,
                startY = null,
                min_left = settings.marginX,
                max_left = width - settings.marginX,
                
                min_top  = settings.marginY,
                max_top  = height - settings.marginY,
                setX = settings.setX,
                setY = settings.setY;
        $this.css('background-image', 'url('+$this.data('passive')+')');
        $changeable.css('background-image', 'url('+$this.data('active')+')');


        $changeable.height($this.height());

        if(setX < min_left) {
            setX = min_left;
        }

        if(setY < min_top) {
            setY = min_top;
        }

        $handle.css('left', setX);

        // Direction
        //////////////////////////////////

        if(settings.direction === "horizontal" ) {
            $changeable.width(setX);
        } 

        else if(settings.direction === "vertical" ) {

                    $this.height($changeable.height());             
                    $changeable.height(setY);               
                    $handle.addClass('vertical');
        }

        // Dragging
        //////////////////////////////////

        $handle.on('mousedown', beginAction);
        $handle.on('touchstart', {isTouch: true}, beginAction);

        $(document).on('mouseup', endAction);
        $(document).on('touchstop', {isTouch: true}, endAction);

        $this.on('mousemove', dragger);
        $this.on('touchmove', {isTouch: true}, dragger);

        function beginAction(e) {
          e.preventDefault();
          $handle.addClass('draggable');
          pos_x  = parseInt($handle.css('left'));
          startX = e.data && e.data.isTouch ? e.originalEvent.pageX
                                            : e.pageX;
        }

        function endAction(e) {
          $handle.removeClass('draggable');
        }

        function dragger(e) {

            var pageX = e.data && e.data.isTouch ? e.originalEvent.targetTouches[0].pageX
                                                 : e.pageX;
            var left = pos_x + (pageX - startX);
            if (left < min_left) left = min_left;
            else if (left > max_left) left = max_left;

            $('.draggable').css('left', left);

            var top = pos_y + (e.pageY - startY);
            if (top < min_top) top = min_top;
            else if (top > max_top) top = max_top;

            if($('.draggable').length) {
                changeWidth(left , top);
            }

        }
        // Changing width or height
        //////////////////////////////////////

        function changeWidth(w , h) {

            if(settings.direction === "horizontal" ) {
                $changeable.width(w);
            } 

            else if(settings.direction === "vertical" ) {
                $changeable.height(h);
            }

        }

    });

}

})(jQuery);
